import { HttpResponse, http } from 'msw';
import { API, BASE_URL_V3 } from '../../../src/common/constants';
import type { ChargingStationMetadataListResponse } from '../../../src/store/facade/facadeApiV3';
import {
    chargePointData1Metadata,
    chargePointData2Metadata,
    chargePointData5Metadata,
    chargePointData6Metadata,
} from '../data/chargePointDataMock';

const URL = `${BASE_URL_V3}${API.endpoints.chargingStations}${API.endpoints.metadata}`;

export const PostSearchStationsMetadataHandler = http.post(URL, async () => {
    return HttpResponse.json({
        hasMore: false,
        chargingStations: [
            chargePointData1Metadata,
            chargePointData2Metadata,
            chargePointData5Metadata,
            chargePointData6Metadata,
        ],
    } as ChargingStationMetadataListResponse);
});

export const PostSearchStationsMetadataErrorHandler = http.post(URL, async () => {
    return HttpResponse.error();
});

export const chargingStationsMetadataResource = {
    success: PostSearchStationsMetadataHandler,
    error: PostSearchStationsMetadataErrorHandler,
};
